// src/InvitationPendingPage.tsx
import React from 'react';
import {
    Box,
    Typography,
    Button,
    Container,
    CircularProgress,
} from '@mui/material';
import { ReactComponent as PendingInvitationSvg } from './logo.svg'; // Make sure to create or have this SVG

interface InvitationPendingPageProps {
    onResendInvitation: () => void;
    resending: boolean;
    userEmail: string | null | undefined;
}

const InvitationPendingPage: React.FC<InvitationPendingPageProps> = ({
    onResendInvitation,
    resending,
    userEmail,
}) => {
    return (
        <Box
            sx={{
                backgroundColor: '#F9FAFB',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Container maxWidth="sm">
                <Box
                    sx={{
                        backgroundColor: 'white',
                        borderRadius: '16px',
                        p: { xs: 3, sm: 5 },
                        textAlign: 'center',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                    }}
                >
                    <Box sx={{ mb: 3 }}>
                    <img src="/icons/pending-invite.svg" alt="Basic Details" style={{ marginRight: '12px', width: '28px', height: '28px' }} />
                    </Box>

                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{ fontWeight: 'bold', mb: 1 }}
                    >
                        Oops! Invitation Still Pending
                    </Typography>

                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ mb: 4 }}
                    >
                        You need to accept the email invitation sent to{' '}
                        <strong style={{ color: '#333' }}>{userEmail || 'your email'}</strong> before
                        you can use the platform. Please check your inbox or spam
                        folder.
                    </Typography>

                    <Button
                        variant="text"
                        onClick={onResendInvitation}
                        disabled={resending}
                        sx={{ textTransform: 'none', fontWeight: 'bold' }}
                    >
                        {resending ? (
                            <CircularProgress size={24} sx={{ mr: 1 }} />
                        ) : null}
                        Didn't receive it? Resend Invitation
                    </Button>
                </Box>
            </Container>
        </Box>
    );
};

export default InvitationPendingPage;